// extracted by mini-css-extract-plugin
module.exports = {"container":"InvoiceStatusTimeline_container__1Wvr0","status":"InvoiceStatusTimeline_status__2QZiY","dot":"InvoiceStatusTimeline_dot__1jgt2"};